import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bac09f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_4 = { class: "content_total" }
const _hoisted_5 = { class: "content_list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "content_list_item_status success"
}
const _hoisted_8 = {
  key: 1,
  class: "content_list_item_status warning"
}
const _hoisted_9 = {
  key: 2,
  class: "content_list_item_status serious"
}
const _hoisted_10 = {
  key: 3,
  class: "content_list_item_status black"
}
const _hoisted_11 = { class: "content_list_item_name" }

import { onMounted, ref, reactive, watch } from 'vue'
    import { checkAllList, toolingList } from '@/apis/WorkOrderAPI'
    import { model } from '@/interface'
    import { Attribute } from '@/enum'
    import { judgmentPlatform } from "@/utils/utils"
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    // 搜索数据接口
    interface form extends model {
        total: number,
        smodelLabel: string,
        categoryId: string
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
        show: {
            type: Boolean,
            required: true
        },
        classification: {   // 是否需要展示分类
            type: Boolean,
            default: false
        },
        attribute: {    // 工装属性
            type: String,
            required: false,
            default: ''
        },
        statusname: {   // 工装状态
            type: String,
            required: false,
            default: '1,2,3'
        }
    },
  emits: ['close', 'value'],
  setup(__props, { emit }) {

const props = __props

    const form = reactive<form>({
        capacity: 50,
        page: 0,
        total: 0,
        smodelLabel: '',
        categoryId: ''
    })

    // 搜索分类标签
    let tagList = ref<Array<{id: string, name: string, num: string}>>([])

    // 列表数据
    const list: any = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false)
    let isOne = ref<boolean>(true)
    const V = ref(null)
    let isOpen = ref<boolean>(true)

    const test = () => {
        const { text } = V.value
        form.smodelLabel = ''
        V.value.text = ''
    }

    const clickTag = (tag: string): void => {
        form.categoryId = tag
        list.value = []
        finished.value = false
        form.page = 0
        form.total = 0
        onLoad()
    }

    // 搜索框
    const searchInput = (data: any) => {
        form.page = 0
        finished.value = false
        list.value = []
        form.smodelLabel = data
        onLoad()
    }

    // 搜索提交
    const submit = (): void => {
        form.page = 0
        finished.value = false
        list.value = []
        onLoad()
    }

    // 返回上一页带参数
    const jump = (item: any) => {
        emit('value', item)
    }

    // 获取工单列表数据
    const onLoad = async () => {
        if (isOne.value && props.classification) await checkAllLists()
        if (!finished.value) {
            loading.value = true;
            form.page = form.page + 1
            toolingList({
                capacity: form.capacity,
                page: form.page,
                model: {
                    categoryId: form.categoryId,
                    code: form.smodelLabel,
                    smodelLabel: props.attribute,
                    statusname: props.statusname
                }
            }).then(res => {
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
                loading.value = false;
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    form.total = res.data.total
                    list.value.push(...res.data.records)
                } else {
                    finished.value = true;
                }
            }).catch((err: any) => {
                loading.value = false;
                finished.value = true;
                if (refreshing.value) {
                    list.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        form.page = 0
        loading.value = true;
        onLoad()
    }

    let status = ref<boolean>(false)

    

    

    // 关闭回调
    const close = () => {
        emit('close')
    }

    // 获取工装器具分类
    const checkAllLists = async () => {
        let res = await checkAllList({
            bmodelCateType: '2'
        })
        if (res.code === 200 && res.data.length !== 0) {
            tagList.value = []
            res.data.forEach((item: any) => {
                tagList.value.push({ id: item.id, name: item.combinationName, num: '' })
            })
            form.categoryId = tagList.value[0].id
            isOne.value = false
        }
    }

    watch(() => props.show, (news) => {
        if (!news) {
            test()
        } else {
            if (!isOpen.value) {
                list.value = []
                finished.value = false;
                form.page = 0
                loading.value = true;
                onLoad()
            }
            isOpen.value = false
        }
    })

    onMounted(() => {
        status.value = judgmentPlatform()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: props.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((props.show) = $event)),
    position: "bottom",
    style: { height: '100%' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close",
          onClick: close
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow-down",
            size: "30",
            color: "#ffffff"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
        }, [
          _createVNode(vSearch, {
            ref_key: "V",
            ref: V,
            onSearchInput: searchInput,
            onSubmit: submit,
            isShow: false,
            placeholder: "搜索工装编码"
          }, null, 512),
          (props.classification)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(vLableSelection, {
                  TagList: _unref(tagList),
                  isShow: false,
                  onChange: clickTag
                }, null, 8, ["TagList"])
              ], 64))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_4, "共" + _toDisplayString(_unref(form).total) + "条数据", 1),
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: onLoad
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content_list_item",
                      key: i,
                      onClick: ($event: any) => (jump(item))
                    }, [
                      (item.smodelLabel === _unref(Attribute).HG)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "[" + _toDisplayString(item.smodelCode) + "]", 1))
                        : (item.smodelLabel === _unref(Attribute).BL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, "[" + _toDisplayString(item.smodelCode) + "]", 1))
                          : (item.smodelLabel === _unref(Attribute).BF)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "[" + _toDisplayString(item.smodelCode) + "]", 1))
                            : (item.smodelLabel === _unref(Attribute).HH)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "[" + _toDisplayString(item.smodelCode) + "]", 1))
                              : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(item.cmodel1BigName) + "-" + _toDisplayString(item.code), 1)
                    ], 8, _hoisted_6))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})